import React, { useRef, useState } from 'react';

import { Flex } from '@chakra-ui/react';

import { ChevronDown, Feedback, Plus } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import FeedbackMenuOptions from './FeedbackMenuOptions';

const AddFeedbackButton = ({
  onClickShareFeedback = () => {},
  onClickRequestFeedback = () => {},
  isQuickAction = false,
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const anchorRef = useRef();

  if (isQuickAction) {
    return (
      <Flex
        ref={anchorRef}
        onClick={(ev) => {
          ev.stopPropagation();
          setMenuIsOpen((prev) => !prev);
        }}
      >
        <Flex
          alignItems="center"
          cursor="pointer"
          gap={2}
          px={3}
          py={2}
          minW="160px"
          background={menuIsOpen ? '#CAE8F0' : 'transparent'}
        >
          <Feedback fill="transparent" boxSize="24px" color="text.g2" />
          <TextBodyMedium color="text.g1">Share/Request feedback</TextBodyMedium>
        </Flex>

        <FeedbackMenuOptions
          shareFeedback={(isSharePublicPraise) => onClickShareFeedback(isSharePublicPraise)}
          requestFeedback={onClickRequestFeedback}
          anchorEl={anchorRef}
          isOpen={menuIsOpen}
          setIsOpen={setMenuIsOpen}
        />
      </Flex>
    );
  }

  return (
    <Flex
      ml={!isMobileView() && 'auto'}
      ref={anchorRef}
      onClick={(ev) => {
        ev.stopPropagation();
        setMenuIsOpen((prev) => !prev);
      }}
    >
      <Button StartIcon={Plus} EndIcon={ChevronDown}>
        Share/Request
      </Button>

      <FeedbackMenuOptions
        shareFeedback={(isSharePublicPraise) => onClickShareFeedback(isSharePublicPraise)}
        requestFeedback={onClickRequestFeedback}
        anchorEl={anchorRef}
        isOpen={menuIsOpen}
        setIsOpen={setMenuIsOpen}
      />
    </Flex>
  );
};

export default AddFeedbackButton;
